import { ImageModule } from './ImageModule';

export class ExhibitionModule extends ImageModule {
	constructor(element: HTMLDivElement) {
		super(element);
	}
}
